export type GTMEvent = {
  event: string;
  status?: boolean;
  detail?: { status?: boolean };
  etc?: string;
  message_id?: string;
  event_callback?: () => void;
};

export type GTMDataLayer = {
  push(data: GTMEvent): number;
};

/**
 * Checks if an email is registered by pushing a GTM event and listening for the response.
 * Resolves true if available for registration, false if already registered.
 */
export function checkEmailStatus(email: string): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const encodedEmail = btoa(email);
    const messageId = Math.random().toString(36).slice(2, 11);
    const gtmDataLayer: GTMDataLayer | undefined =
      (window.parent && window.parent.gtmDataLayer) || window.gtmDataLayer;
    if (!gtmDataLayer) {
      reject(new Error("gtmDataLayer not found"));
      return;
    }
    const originalPush: GTMDataLayer["push"] = gtmDataLayer.push;
    let settled = false;
    const timeoutId = setTimeout(() => {
      if (!settled) {
        gtmDataLayer.push = originalPush;
        settled = true;
        reject(new Error("Request timeout"));
      }
    }, 2000);
    gtmDataLayer.push = function (data: GTMEvent): number {
      const result = originalPush.call(this, data);
      if (!settled && data && data.event === "cesResult") {
        const status = Object.prototype.hasOwnProperty.call(data, "status")
          ? data.status
          : data.detail &&
            Object.prototype.hasOwnProperty.call(data.detail, "status")
          ? data.detail.status
          : undefined;
        if (typeof status === "boolean") {
          clearTimeout(timeoutId);
          gtmDataLayer.push = originalPush;
          settled = true;
          resolve(!!status); // false = unavailable, true = available for registration
          return result;
        } else if (status !== undefined) {
          clearTimeout(timeoutId);
          gtmDataLayer.push = originalPush;
          settled = true;
          reject(new Error("Unexpected response format"));
          return result;
        }
        return result;
      }
      return result;
    };
    gtmDataLayer.push({
      event: "ces",
      etc: encodedEmail,
      message_id: messageId,
      event_callback: function () {},
    });
  });
}
